import { useInterval } from "@hooks/index";
import type React from "react";
import { useState } from "react";
import { Flex } from "../Flex";
import styles from "./Clock.module.scss";

const Clock: React.FC = () => {
  const [currentHour, setCurrentHour] = useState(new Date());
  useInterval(1000, () => setCurrentHour(new Date()));

  return (
    <Flex alignItems="center" className={styles.container}>
      {currentHour.toLocaleTimeString("pt-BR", {
        timeZone: "America/Sao_Paulo",
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      })}
    </Flex>
  );
};

export default Clock;
